import { FC, useState, useRef, useEffect } from 'react'
import PdImage from '../pd-image/pd-image'

interface UploadProps {
  maxSize?: number
  extra?: string
  label: string
  className?: string
  rule?: any
  onChange: (file?: File) => void
}
const PdUpload: FC<UploadProps> = ({ label, rule, extra, maxSize = 10, className, onChange }) => {
  const [files, setFiles] = useState<File>()
  const [inputVal, setInputVal] = useState<string>()
  const [showerrorTips, setShowErrorTips] = useState<string>('')
  const [isMobileDevice, setMobileDevice] = useState<boolean>(false)
  const fileInputField = useRef<any>(null)
  const defaultFileType = ['ppt', 'pptx', 'pdf', 'xls', 'xlsx', 'docx', 'doc', 'png', 'jpeg', 'jpg', 'dng', 'mp4']
  function onClickUploadBtn() {
    fileInputField?.current?.click()
  }

  function addFile(file: File, inputValue?: string) {
    const fileType = file?.name?.split('.')?.[file?.name?.split('.')?.length - 1]
    if (file?.size > maxSize * 1024 * 1024) {
      removeFile()
      setShowErrorTips('File size is too large.')
    } else if (!defaultFileType.includes(fileType)) {
      removeFile()
      setShowErrorTips('Unsupported file type for upload.')
    } else {
      setShowErrorTips('')
      setFiles(file)
      setInputVal(inputValue)
      onChange(file)
    }
  }

  function removeFile() {
    fileInputField.current.value = ''
    setFiles(undefined)
    setInputVal('')
    onChange(undefined)
  }

  useEffect(() => {
    setMobileDevice(window?.innerWidth < 1024)
  }, [])

  return (
    <div className={[className, 'flex flex-col flex-1 text-base text-black/90 col-span-2'].join(' ')}>
      <label className="font-semibold">
        {label}
        {rule && rule.required && <sup className="text-red">*</sup>}
      </label>
      <p className="mt-3 laptop:mt-2 mb-6 laptop:mb-4 text-black/60 laptop:text-12 text-14">{extra}</p>
      <div
        className={['w-full laptop:h-110px relative rounded-sm overflow-hidden', files?.name ? 'h-30' : 'h-12'].join(
          ' '
        )}
        onClick={() => isMobileDevice && onClickUploadBtn()}
      >
        <PdImage src={'/feedback/dashed.png'} enableMask={false} object="fill" width={'100%'} height={'100%'} />
        <div
          id="drag-box"
          className={[
            'w-full h-full absolute top-0',
            files?.name ? 'bg-pdbg laptop:p-4 p-3' : 'flex items-center justify-center',
          ].join(' ')}
          onDragEnterCapture={(e) => {
            e.preventDefault()
            e.stopPropagation()
          }}
          onDragOverCapture={(e) => {
            e.preventDefault()
            e.stopPropagation()
          }}
          onDragLeaveCapture={(e) => {
            e.preventDefault()
            e.stopPropagation()
          }}
          onDropCapture={(e) => {
            e.preventDefault()
            e.stopPropagation()
            const fileList: FileList | undefined = e?.dataTransfer?.files
            if (fileList) {
              addFile(fileList?.[0])
            }
          }}
        >
          {files?.name && (
            <div className="bg-white w-full h-11 laptop:px-4 px-3 flex items-center justify-between">
              <span className="font-semibold">{files?.name}</span>
              <div
                className="laptop:w-3 laptop:h-14px w-18px h-21px cursor-pointer"
                onClick={(e) => {
                  e.preventDefault()
                  e.stopPropagation()
                  removeFile()
                }}
              >
                <PdImage
                  src={'/feedback/delete.png'}
                  enableMask={false}
                  object="cover"
                  width={'100%'}
                  height={'100%'}
                />
              </div>
            </div>
          )}
          <div
            className={[
              'w-full laptop:px-4 px-0 flex items-center text-14 laptop:text-black/90 text-black/60',
              files?.name ? 'justify-between laptop:mt-10px mt-4' : 'flex-col justify-center',
            ].join(' ')}
          >
            {files?.name && (
              <span>
                {files?.size && Math.round(files?.size / 1024) <= 100
                  ? (files?.size / 1024).toFixed(1) + ' KB'
                  : (files?.size / 1024 / 1024).toFixed(1) + ' MB'}
              </span>
            )}
            <div className="flex gap-2">
              <div className="relative cursor-pointer">
                <span className="text-[#0066FF] relative cursor-pointer z-10" onClick={onClickUploadBtn}>
                  {files?.name
                    ? isMobileDevice
                      ? 'Replace'
                      : 'Replace a file'
                    : isMobileDevice
                      ? 'Upload'
                      : 'Upload a file'}
                </span>
                <input
                  className="absolute m-0 p-0 w-full h-full top-0 right-0 opacity-0 outline-0 cursor-pointer z-0"
                  ref={fileInputField}
                  id="upload-input"
                  accept={defaultFileType.map((item) => '.' + item).join(',')}
                  type="file"
                  value={inputVal}
                  alt="pudutech pudurobotics uploader"
                  onChange={(e) => {
                    const fileList: FileList | null = e?.target?.files
                    const val: string = e?.target?.value
                    if (fileList) {
                      addFile(fileList?.[0], val)
                    }
                  }}
                />
              </div>
              {!isMobileDevice && <span>{' or drag and drag here'}</span>}
            </div>
            {!isMobileDevice && showerrorTips && (
              <p className="text-[#F52242] text-14 text-center mt-2">{showerrorTips}</p>
            )}
          </div>
        </div>
      </div>
      {isMobileDevice && showerrorTips && <p className="text-[#F52242] text-14 text-center mt-2">{showerrorTips}</p>}
    </div>
  )
}

export default PdUpload
